import React, { useState, useEffect } from 'react';
import { Constants } from '../Constants';

const VehicleInfoInputCard = (props) => {
  	const [vehicleInfo, updateVehicleInfoArray] = useState(JSON.parse(JSON.stringify(Constants.defaultVehicleInputData)));
  	const [vehicleModelList, updateVehicleModelDatalist] = useState(null);

	useEffect(
		() => {
			updateVehicleInfoArray(props.values);
		},
		[props.values]
	);

	const handleChange = (event) => {
		var nameSplitArray = event.target.name.split(".");
		
		var key = nameSplitArray[nameSplitArray.length-1];
		var value = event.target.value;
		
		props.onUpdate(props.id, key, value);		
	}

	const fetchDataForVIN = (event) => {
		var VIN = event.target.value;
		
		if(VIN.length != 17){
			return;
		}
		var keyValuePairs = {keys: ["Make","Model","Year"], values: []};
		fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/' + VIN + '?format=json')
			.then(response => response.json())
			.then(data => {
				keyValuePairs.values[0] = data["Results"]["6"]["Value"];
				keyValuePairs.values[1] = data["Results"]["8"]["Value"];
				keyValuePairs.values[2] = data["Results"]["9"]["Value"];
				
				props.onUpdateMultiple(props.id, keyValuePairs);
			});
	}
	
	const fetchModelsForMake = (event) => {
        var make = event.target.value;
        
        if(make.length == 0){
            return;
        }
        var innerData, dataList;
        fetch('https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMake/' + make + '?format=json')
            .then(response => response.json())
            .then(data => {
                innerData = data["Results"].map((result,index) => <option key={index}>{result["Model_Name"]}</option>);
                dataList = <datalist id={"modelList" + props.id}>{innerData}</datalist>;     
                updateVehicleModelDatalist(dataList);
            });
	}
	
	// RJM 10/28/2020: bound to Models\Freight\Vehicles\Vechicle.cs > VehicleViewModel
	var baseInputName = props.baseInputName;
	var VINinput = baseInputName + "[" + props.id + "].VIN";
	var makeInput = baseInputName + "[" + props.id + "].Make";
	var modelInput = baseInputName + "[" + props.id + "].Model";
	var yearInput = baseInputName + "[" + props.id + "].Year";
	var conditionInput = baseInputName + "[" + props.id + "].vehicleCondition";
	var vehicleTypeInput = baseInputName + "[" + props.id + "].VehicleType"
	var freeTextTypeInput = baseInputName + "[" + props.id + "].userFreeTextedVehicleType"
	var memberInput = baseInputName + "[" + props.id + "].memberNumber";
	var lotInput = baseInputName + "[" + props.id + "].lotNumber";
	var attributeEditIdInput = baseInputName + "[" + props.id + "].attributeEditId";
	var vehicleEditIdInput = baseInputName + "[" + props.id + "].vehicleEditId";
	var conditionToolTip = baseInputName + "[" + props.id + "].conditionToolTip";

	var modelListName = "modelList" + props.id;
	var removeButton,yearOptionsList,documentUploadConf;
	
	var years = [];
	for(var i = new Date().getFullYear(); i >= 1970; i--){
		years.push(i.toString());
	}
	yearOptionsList = years.map((year,index) => <option key={index} value={year}>{year}</option>);
	
  	return (
		<div className="col-sm-12 col-md-6 mb-2">
			<div className="card border border-muted shadow-3 p-2">
				<div className="row align-items-center mb-2">
					<div className="col-sm-3">                    
						<strong>Vehicle #{parseInt(props.id,10) + 1}</strong>
					</div>
					{!props.editMode &&
						<div className="col-sm-9">
							<div className="row">
								<div className="col-auto ml-auto">
									<button type="button" className="btn btn-danger" onClick={() => props.onRemove(parseInt(props.id))}>
										Remove Vehicle
									</button>
								</div>
							</div>
						</div>
					}
					<div className="col-12">
						<label className="control-label">Vehicle VIN #</label>
					</div>
					<div className="col-md-4 col-sm-6 mt-2 mt-md-0">                    
						<input name={VINinput} className="form-control vinlength" value={props.values["VIN"]}
							onBlur={fetchDataForVIN} onChange={evt => handleChange(evt)}/>
					</div>
					<div className="w-100"></div>

					<div className="col-md-4 col-sm-6 mt-2 mt-md-0">
						<label className="control-label">Make</label>                
						<input required name={makeInput} className="form-control" value={props.values["Make"]}
							onBlur={fetchModelsForMake} onChange={evt => handleChange(evt)} list="makeList"/>
						{Constants.vehicleMakeList("makeList")}
					</div>
					<div className="col-md-4 col-sm-6 mt-2 mt-md-0">
						<label className="control-label">Model</label>
						<input required name={modelInput} className="form-control" value={props.values["Model"]}
							onChange={evt => handleChange(evt)} list={modelListName}/>
						{vehicleModelList}
					</div>
					<div className="col-md-4 col-sm-6 mt-2 mt-md-0">
						<label className="control-label">Year</label>
						<select required name={yearInput} className="form-select" value={props.values["Year"]}
							onChange={evt => handleChange(evt)}
							>
						{yearOptionsList}
						</select>
					</div>   
					<div className="col-md-4 col-sm-6 mt-2 mt-md-0">
						<label className="control-label">Condition</label>
						<span className="dropdown">
							<a id={conditionToolTip} data-toggle="dropdown" className="badge bg-info dropdown-toggle ml-2" aria-expanded="false">Info</a>
							<div className="dropdown-menu" style={{"max-width":"800px","width":"90vw"}} aria-labelledby={conditionToolTip}>
								<div className="alert alert-info mb-0 pb-n1 border border-black">
									<ul>
										<li className="mb-1">Choose <strong>Running</strong> if the vehicle starts and drives normally.</li>
										<li className="mb-1">Choose <strong>Non-Running</strong> if the vehicle does not start, but can be moved/rolled on its own set of wheels.</li>
										<li className="mb-1">Choose <strong>Needs forklift trailer</strong> if the vehicle does not start, and cannot be moved/rolled on its own wheels.</li>
									</ul>
								</div>
							</div>
						</span>
						<select name={conditionInput} className="form-select" value={props.values["vehicleCondition"]}
							onChange={evt => handleChange(evt)}>
							<option value={Constants.vehicleMoveCondition.Running.value}>
								{Constants.vehicleMoveCondition.Running.displayValue}
							</option>
							<option value={Constants.vehicleMoveCondition.NonRunning.value}>
								{Constants.vehicleMoveCondition.NonRunning.displayValue}
							</option>
							<option value={Constants.vehicleMoveCondition.ForkliftNeeded.value}>
								{Constants.vehicleMoveCondition.ForkliftNeeded.displayValue}
							</option>
						</select>
					</div>
					<div className="col-md-4 col-sm-6 mt-2 mt-md-0">
						<label className="control-label">Vehicle type</label>
						<select name={vehicleTypeInput} value={props.values["VehicleType"]} onChange={evt => handleChange(evt)} className="form-select">
							{Object.keys(Constants.VehicleType).map(key => 
								<option value={key}>{Constants.VehicleType[key]}</option>
							)}
						</select>
					</div>
					{props.values["VehicleType"] == "Other" &&
						<div className="col-md-4 col-sm-6 mt-2 mt-md-0">
							<label className="control-label" >Vehicle type</label>
							<input name={freeTextTypeInput} className="form-control" 
								value={props.values["userFreeTextedVehicleType"]}
								onChange={evt => handleChange(evt)} />
						</div>
					}
					{props.auctionDetailsNeeded
						&&
						<div className="col-12">
							<div className="row">
								<div className="col-md-6 col-sm-12 mt-sm-2">
									<label className="control-label">Lot Number</label>                
									<input required name={lotInput} value={props.values["lotNumber"]} className="form-control"
										onChange={evt => handleChange(evt)}/>
								</div>
								<div className="col-md-6 col-sm-12 mt-sm-2">
									<label className="control-label">Member Number</label>                
									<input required name={memberInput} value={props.values["memberNumber"]} className="form-control"
										onChange={evt => handleChange(evt)}/>
								</div>
							</div>
						</div>
					}
					{props.editMode &&
						<div>
							<input type="hidden" value={props.values["attributeEditId"]} name={attributeEditIdInput}/>
							<input type="hidden" value={props.values["vehicleEditId"]} name={vehicleEditIdInput} />
						</div>
					}
				</div>
			</div>
		</div>
	);
}

export { VehicleInfoInputCard };